/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
export const REGISTER_ASSET = 'Register New Asset'
export const ATTACH_SUPPLEMENTAL_CONTENT = 'Attach supplemental content'
export const REVENUE_BREAKDOWN = 'Revenue Breakdown'
export const DOWNLOAD = 'Download'
export const SET_COVER_IMAGE = 'Set cover image'
export const MASKING = 'Masking'
export const LIST_AI_LICENSING = 'List for AI Licensing'
export const RESTORE_DEFAULT_TERMS = 'Restore default terms'
export const REGISTER_MISSING_PDS_ASSETS = 'Register Missing PDS Assets'
export const REGISTER_MISSING_ASSETS = 'Register Missing Assets'
export const VIEW_ASSET_DETAILS = 'View Asset Details'
export const ASSET_METADATA = 'Asset metadata'
export const LIST_ASSETS_FOR_BUILDINGS_SAMS = 'List Asset for Building SAMS'
